module.exports = __webpack_public_path__ + "static/img/xueshengappbg.04f3517.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xueshengappbg.png
// module id = sE2E
// module chunks = 10